// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_ix","advertCardFooter__row":"c-a_iy","advertCardFooter__name":"c-a_iz","advertCardFooter__price":"c-a_iA","advertCardFooter__age":"c-a_iB"};